import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/check-in-circle.svg")